(function () {
    'use strict';

    angular.module("imApp").factory("projectInvoicingService", ['$ihttp', function ($ihttp) {
        let service = {
            getProjectInvoicing: function (parms) {
                return $ihttp.post({
                    method: 2198,
                    parameters: parms || {}
                });
            },
            createInvoice: function (mergeObj) {
                return $ihttp.post({
                    method: 2200,
                    parameters: mergeObj
                });
            },
            setNotInvoice: function (mergeObj) {
                return $ihttp.post({
                    method: 2201,
                    parameters: mergeObj
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 2204,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
